
import { defineComponent, computed, PropType, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import GroupPolicyDrawer from '@/views/dashboard/_components/group-policy-settings/group-policy-drawer.vue'
import { ClientStrategyRes } from '@/views/dashboard/group/client/client.service'
import { ClientItem } from '@/views/dashboard/_type/client-item'

const SWITCH_KEYS = ['exam_switch', 'virus_switch', 'system_disk_used_switch', 'hard_disk_used_switch', 'cpu_used_switch', 'memory_used_switch', 'cpu_temperature_switch', 'disk_temperature_switch', 'net_up_speed_switch', 'net_down_speed_switch']
export default defineComponent({
  name: 'ClientDefencePolicyModal',
  components: { GroupPolicyDrawer },
  props: {
    groupId: {
      type: Number,
      default: -1
    },
    show: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object as PropType<ClientItem>,
      default: {} as PropType<ClientItem>
    },
    defenceStrategy: {
      type: Object as PropType<ClientStrategyRes>,
      default: {} as PropType<ClientStrategyRes>
    },
  },
  emits: ['closeClientModal'],
  setup(props, context) {
    const { t, locale } = useI18n()
    // eslint-disable-next-line no-magic-numbers
    const Windows_Platform = [1, 3] // win and winserver
    const groupPolicyDrawerVisible = ref(false)
    const modalVisible = computed(() => props.show)

    const strategy = computed(() => props.defenceStrategy?.info || {} as any)

    const columnTitles = computed(() => {
      const _localeDep = locale.value
      return {
        virus_detection: t('groupClient.defencePolicyColVirusDetection'),
        system_protection: t('groupClient.defencePolicyColSystemProtection'),
        regular_exam: t('groupClient.defencePolicyColRegularExam'),
        regular_scan: t('groupClient.defencePolicyColRegularScan'),
        flow_control: t('groupClient.defencePolicyColFlowControl'),
        early_warning: t('groupClient.defencePolicyColEarlyWarning'),
        leak_repair: t('groupClient.defencePolicyColLeakRepair'),
        baseline_check: t('groupClient.defencePolicyColBaselineCheck'),
      }
    })

    const modalTitle = computed(() => {
      const name = props.row?.computer_name
        ? props.row.computer_name
        : t('groupClient.defencePolicyUnnamedTerminal')
      return t('groupClient.defencePolicyModalTitle', { name })
    })

    const strategyNameLine = computed(() => {
      const name = props.defenceStrategy?.strategy_name || t('groupClient.defencePolicyDefaultStrategy')
      return `${t('groupClient.defencePolicyStrategyNameLabel')}${name}`
    })

    function showGroupPolicyDrawer() {
      groupPolicyDrawerVisible.value = true
      closeModal()
    }

    function closeModal() {
      context.emit('closeClientModal', 'MODAL_CLIENT_DEFENCE_POLICY')
    }

    return {
      columnTitles,
      modalTitle,
      strategyNameLine,
      Windows_Platform,
      modalVisible,
      groupPolicyDrawerVisible,
      strategy,
      showGroupPolicyDrawer,
      closeModal,
      calcEarlyWarnCount() {
        let sum = 0
        SWITCH_KEYS.forEach(key => {
          sum = sum + (strategy.value?.early_warning?.[key] ? 1 : 0)
        })
        return sum
      },
    }
  }
})
